






import Vue from 'vue';

export default Vue.extend({
  name: 'Vertical',
  props: {
    height: {
      type: String,
      default: null,
    },
    reverse: {
      type: Boolean,
      default: false,
    },
    align: {
      type: String,
      default: 'start',
    },
    base: {
      type: String,
      default: 'start',
    },
  },
});
